import React, { Fragment } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';


const HeaderContainer = styled.div`
  width: calc(100% - 80px);
  height: 30px;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 10px 40px;
  z-index: 3;
  background-color: var(--accent);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
  cursor: pointer;
`;

const MobileHeaderContainer = styled(HeaderContainer)`
  width: calc(100% - 40px);
  padding: 10px 20px;
  height: 20px;
`;


export const Banner = ({children, onClick, backgroundColor='var(--accent)'}) => {

  if (isMobile) {
    return (
      <MobileHeaderContainer onClick={onClick} style={{backgroundColor}}>
        {children}
      </MobileHeaderContainer>
    );
  }

  return (
    <HeaderContainer onClick={onClick} style={{backgroundColor}}>
      {children}
    </HeaderContainer>
  );
};
